<div class="container-fluid login-component" *ngIf="showToggle">
	<div class="login-page d-flex flex-column justify-content-center align-items-center">
		<img src="./assets/images/logo.svg" alt="login-logo" class="login-logo" />
		<!-- <div class="custom-card shadow">
			<button class="google-sign-in" (click)="signInHandler()">
				<img src="https://developers.google.com/identity/images/btn_google_signin_dark_normal_web.png" alt="google"/>
			</button>
		</div> -->
		<div>

			<form class="custom-form" [formGroup]="loginForm" (ngSubmit)="signInHandler()">
				<div class="form-control-box form-group bottom-spacing">
					<label for="email">Email : </label>
					<input type="email" name="email" class="form-control" placeholder="Enter Email Address"
						formControlName="vEmail">
				</div>
				<div class="form-control-box field-with-icon form-group">
					<label for="password">Password : </label>
					<input [type]="hidePassword ? 'password' : 'text'" class="form-control" id="password"
						placeholder="Enter Password" formControlName="vPassword">
					<button type="button" class="icon-btn" (click)="hidePassword = !hidePassword">
						<img height="20" width="20"
							[src]="hidePassword ? './assets/images/close-eye-icon.svg' : './assets/images/eye-icon.svg' "
							alt="eye-icon">
					</button>
				</div>
				<div class="text-right forget-pass">
					<a class="grey-text" routerLink="/forgot-password">Forget Password ?</a>
				</div>

				<div class="text-center bottom-spacing">
					<button type="submit" class="active-btn btn w-100 mt-3">Login</button>
				</div>
			</form>
			<div class="text-center sign-up">
				Don`t have an account ? <button class="grey-text" (click)="showToggle = !showToggle">Sign Up</button>
				here.
			</div>
		</div>
	</div>
</div>
<div class="container-fluid login-component" *ngIf="!showToggle">
	<div class="login-page d-flex flex-column justify-content-center align-items-center">
		<!-- <img src="./assets/images/logo.svg" alt="login-logo" class="login-logo" /> -->
		<h4 class="auth-heading">Sign Up</h4>
		<div>
			<form class="custom-form" [formGroup]="signUpForm" (ngSubmit)="signUpHandler()">
				<div class="row bottom-spacing">
					<div class="col-6">
						<div class="form-control-box form-group">
							<label for="firstName">First Name : </label>
							<input type="text" name="firstName" class="form-control" placeholder="Enter First Name"
								formControlName="vFirstName">
						</div>
					</div>
					<div class="col-6">
						<div class="form-control-box form-group">
							<label for="lastName">Last Name : </label>
							<input type="text" name="lastName" class="form-control" placeholder="Enter Last Name"
								formControlName="vLastName">
						</div>
					</div>
				</div>
				<div class="form-control-box form-group bottom-spacing">
					<label for="email">Email : </label>
					<input type="email" name="email" class="form-control" placeholder="Enter Email Address"
						formControlName="vEmail">
				</div>
				<div class="form-control-box field-with-icon form-group bottom-spacing">
					<label for="password">Password : </label>
					<input [type]="hidePassword ? 'password' : 'text'" class="form-control" id="password"
						placeholder="Enter Password" formControlName="vPassword">
					<button type="button" class="icon-btn" (click)="hidePassword = !hidePassword">
						<img height="20" width="20"
							[src]="hidePassword ? './assets/images/close-eye-icon.svg' : './assets/images/eye-icon.svg' "
							alt="eye-icon">
					</button>
				</div>
				<div class="form-control-box field-with-icon form-group bottom-spacing">
					<label for="confirmPassword">Confirm Password : </label>
					<input [type]="hidePassword1 ? 'password' : 'text'" class="form-control" id="confirmPassword"
						placeholder="Enter Confirm Password" formControlName="confirmPassword">
					<button type="button" class="icon-btn" (click)="hidePassword1 = !hidePassword1">
						<img height="20" width="20"
							[src]="hidePassword1 ? './assets/images/close-eye-icon.svg' : './assets/images/eye-icon.svg' "
							alt="eye-icon">
					</button>
				</div>
				<div class="text-center bottom-spacing">
					<input type="submit" class="btn w-100 mt-3 active-btn" value="Sign Up">
				</div>
			</form>
			<div class="text-center sign-up">
				Already have an account ? <button class="grey-text" (click)="showToggle = !showToggle">Sign In</button>
				here.
			</div>
		</div>
	</div>
</div>